<div [class]="options?.cssClass + 'dynamic-form  w-full'" >
    <div *ngIf="options?.hidden == false" class="flex flex-row w-full">

        <ng-container *ngIf="data == undefined || null">
            <div class="flex flex-col px-2 w-1/2 grow">
                <div class="mb-2">{{languages.CreatedBy | translate}}</div>
                <div class="zone-created h-auto w-full justify-center content-center">
                  {{''}} - {{'' | date:'dd-MM-YYYY / HH:mm'}}
                </div>
              </div>

              <div class="flex flex-col px-2 w-1/2 grow">
                <div class="mb-2">{{languages.EditedBy | translate}}</div>
                <div class="zone-edited h-auto w-full px-2">
                  {{''}} - <span>{{'' | date:'dd-MM-YYYY / HH:mm'}}</span>
                </div>
              </div>
        </ng-container>

        <ng-container *ngIf="data" class="flex flex-row w-full">
            <div class="flex flex-col px-2 text-center w-1/2 ">
                <div class="mb-1">{{languages.CreatedBy | translate}}</div>
                <div class="zone-created h-auto w-full ">
                  {{data.createdBy}} - {{data.creationDate  | date:'dd-MM-YYYY / HH:mm'}}
                </div>
              </div>

              <div class="flex flex-col px-2 text-center w-1/2 ">
                <div class="mb-1">{{languages.EditedBy | translate}}</div>
                <div class="zone-edited h-auto w-full ">
                  <p>
                    {{data.editedBy}} - <span *ngIf="data.lastEditDate != data.creationDate">{{data.lastEditDate | date:'dd-MM-YYYY / HH:mm'}}</span>
                  </p>
                </div>
              </div>
        </ng-container>


      </div>
</div>
